import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import ApiRequest from "../Common/restservice";
import { errorToast } from "../Common/showtoast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import emptycart from "../Assets/Images/cart.png";
import CompanyGrid from "../Components/CompanyGrid";
import IndividualGrid from "../Components/IndividualGrid";
import { FaStar } from "react-icons/fa6";
function AllProviders() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const searchtext = params.get("txt");
  const [advancedFilters, setAdvancedFilters] = useState({ experience: "" });
  const [advanceAppliedFilters, setAdvanceAppliedFilters] = useState(null);
  const [serviceProviders, setserviceProviders] = useState([]);
  const _location = params.get("location");
  const _category = params.get("category");
  const pageno = params.get("pageno") || 1;

  const [location, setLocation] = useState("");
  // const [pageno, setpageno] = useState(1);
  const [selectCategories, setselectCategories] = useState(
    _category || "provider"
  );
  const [searchText, setsearchText] = useState("");
  const [stateObj, setStateObj] = useState({});

  useEffect(() => {
    if (localStorage.getItem("token")) GetMyProfile();
  }, []);
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("accounts.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  useEffect(() => {
    window.scrollTo(0, 50);
    if (searchtext) setsearchText(searchtext);
    if (_location) setLocation(_location);
    if (_category) setselectCategories(_category);
    GetServiceProviders(searchText || searchtext, _location, _category);
  }, [pageno, searchtext, _location, _category]);
  useEffect(() => {
    if (advanceAppliedFilters !== null)
      GetServiceProviders(searchText, location, selectCategories);
  }, [advanceAppliedFilters]);
  const GetServiceProviders = async (_txt, _loc, _cat) => {
    setserviceProviders([]);
    let obj = {
      pageno: pageno || 1,
      searchtext: _txt || "",
      location: _loc,
    };
    if (advanceAppliedFilters) {
      Object.entries(advanceAppliedFilters).forEach(([key, value]) => {
        obj[key] = value;
      });
    }
    let res = await ApiRequest(
      _cat === "freelancer" ? "search_freelancer.asp" : "search_company.asp",
      "POST",
      JSON.stringify(obj)
    );
    if (res.status === "error") {
      setserviceProviders([]);
      errorToast(res.message);
      return;
    }
    // if (sortBy === "latest") {
    //   let records = res.items.sort(
    //     (a, b) => moment(b.joiningdate).unix() - moment(a.joiningdate).unix()
    //   );
    //   setserviceProviders(records);
    // } else {
    //   let records = res.items.sort(
    //     (a, b) => moment(a.joiningdate).unix() - moment(b.joiningdate).unix()
    //   );
    //   setserviceProviders(records);
    // }
    console.log(res.items);
    setserviceProviders(res.items);
  };
  useEffect(() => {
    console.log(advancedFilters);
  }, [advancedFilters])
  return (
    <>
      <section
        className="banner-1 cover-image sptb-4 sptb-tab bg-background33"
        style={{ background: `url(${banner}) center center` }}
      >
        <div className="header-text text mb-0">
          <div className="container">
            <div className="text-center text-white ">
              <h1 className="" style={{ fontWeight: "bold", paddingTop: 50 }}>
                Find Freelance marketers or Businesses
              </h1>
              <p style={{ fontWeight: "bold", fontSize: 18 }}>
                With thousands of users, we just have the right one for you
              </p>
            </div>
            <div className="row">
              <div className="col-xl-8 col-lg-12 col-md-12 d-block mx-auto">
                <div className="item-search-tabs">
                  {/* <div className="item-search-menu">
                    <ul className="nav">
                      <li className="">
                        <a
                          href="#"
                          style={{ fontWeight: "bold" }}
                          class={
                            selectCategories === "freelancer"
                              ? "bg-primary active"
                              : ""
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setselectCategories("freelancer");
                          }}
                        >
                          Freelance Marketer
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          style={{ fontWeight: "bold" }}
                          class={
                            selectCategories === "provider"
                              ? "bg-primary active"
                              : ""
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setselectCategories("provider");
                          }}
                        >
                         Business
                        </a>
                      </li>
                    </ul>
                  </div> */}
                  <div className="tab-content index-search-select">
                    <div className="tab-pane active">
                      <div className=" search-background bg-transparent">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            // setpageno(1);
                            navigate(
                              `/allproviders?category=${selectCategories}&txt=${searchText || ""
                              }&location=${location || ""}`
                            );
                          }}
                          className="form row g-0"
                        >
                          <div className="form-group col-xl-12 col-lg-12  col-md-12 mb-0 location">
                            <div className="row g-0 br-0">
                              <div className="fa-select-wrapper form-group  col-xl-3 col-lg-3 col-md-12 mb-0 bg-white ">
                                <select
                                  type="text"
                                  className="form-control custom-select"
                                  id="employe-text"
                                  value={selectCategories}
                                  onChange={(e) =>
                                    setselectCategories(e.target.value)
                                  }
                                >
                                  <option value={"freelancer"}>
                                    Freelance Marketer
                                  </option>
                                  <option value={"provider"}>
                                    Businesses
                                  </option>
                                </select>
                              </div>
                              <div className="form-group  col-xl-3 col-lg-3 col-md-12 mb-0 bg-white ">
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  placeholder="Enter location"
                                  value={location}
                                  onChange={(e) => setLocation(e.target.value)}
                                />
                                <span>
                                  <i class="fa fa-map-marker location-gps me-1"></i>
                                </span>
                              </div>
                              <div className="form-group  col-xl-4 col-lg-3 col-md-12 mb-0 bg-white ">
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  placeholder="Enter industry e.g., Real estate, Healthcare, Education...."
                                  value={searchText}
                                  onChange={(e) =>
                                    setsearchText(e.target.value)
                                  }
                                />
                              </div>
                              <div className="col-xl-2 col-lg-3 col-md-12 mb-0">
                                <button
                                  type="submit"
                                  className="btn btn-block btn-primary fs-14"
                                >
                                  <i className="fa fa-search"></i> Search
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {advanceAppliedFilters && (
        <section class="sptb py-2 pt-5">
          <div class="container">
            <div class="row">
              {Object.entries(advanceAppliedFilters).map(([key, value]) => {
                if (!value) {
                  return <></>
                }
                if (key === "rating") {
                  return (
                    <div className="btn-group  btn-group-sm  w-auto">
                      <div
                        className="btn border-primary"
                        style={{
                          borderTopLeftRadius: 20,
                          borderBottomLeftRadius: 20,
                        }}
                      >
                        <label
                          class="text-dark mb-0"
                          style={{
                            verticalAlign: "middle",
                            alignItems: "center",
                          }}
                        >
                          Rating : {advanceAppliedFilters.rating}
                          <FaStar size={14} className="text-yellow" />
                        </label>
                      </div>
                      <div
                        style={{
                          borderTopRightRadius: 20,
                          borderBottomRightRadius: 20,
                        }}
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setAdvanceAppliedFilters({
                            ...advanceAppliedFilters,
                            rating: "",
                          });
                          setAdvancedFilters({
                            ...advancedFilters,
                            rating: "",
                          });
                        }}
                      >
                        <i className="fa fa-times text-danger fs-16" />
                      </div>
                    </div>
                  );
                } else if (key === "year") {
                  <div className="btn-group  btn-group-sm  w-auto">
                    <div
                      className="btn border-primary"
                      style={{
                        borderTopLeftRadius: 20,
                        borderBottomLeftRadius: 20,
                      }}
                    >
                      <label
                        class="text-dark mb-0"
                        style={{
                          verticalAlign: "middle",
                          alignItems: "center",
                        }}
                      >
                        {selectCategories === "freelancer"
                          ? "Experience"
                          : "Estabilished"}
                        : {advanceAppliedFilters.year}+ Years
                      </label>
                    </div>
                    <div
                      style={{
                        borderTopRightRadius: 20,
                        borderBottomRightRadius: 20,
                      }}
                      className="btn btn-outline-primary"
                      onClick={() => {
                        setAdvanceAppliedFilters({
                          ...advanceAppliedFilters,
                          year: "",
                        });
                        setAdvancedFilters({ ...advancedFilters, year: "" });
                      }}
                    >
                      <i className="fa fa-times text-danger fs-16" />
                    </div>
                  </div>;
                }
                return (
                  <div className="btn-group  btn-group-sm  w-auto">
                    <div
                      className="btn border-primary"
                      style={{
                        borderTopLeftRadius: 20,
                        borderBottomLeftRadius: 20,
                      }}
                    >
                      <label
                        class="text-dark mb-0 text-capitalize"
                        style={{
                          verticalAlign: "middle",
                          alignItems: "center",
                        }}
                      >
                        {key === "sub_category" ? "Category" : key} : {value}
                      </label>
                    </div>
                    <div
                      style={{
                        borderTopRightRadius: 20,
                        borderBottomRightRadius: 20,
                      }}
                      className="btn btn-outline-primary"
                      onClick={() => {
                        let newobj = {
                          ...advanceAppliedFilters,
                        };
                        newobj[key] = "";
                        setAdvanceAppliedFilters(newobj);
                        setAdvancedFilters(newobj);
                      }}
                    >
                      <i className="fa fa-times text-danger fs-16" />
                    </div>
                  </div>
                );
              })}
              <div
                className="btn  btn-sm border-primary w-auto"
                style={{ borderRadius: 20 }}
                onClick={() => {
                  setAdvanceAppliedFilters("");
                  setAdvancedFilters("");
                }}
              >
                Clear Filter <i className="fa fa-times text-danger fs-16" />
              </div>
            </div>
          </div>
        </section>
      )}
      <section class="sptb">
        <div class="container">
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Category</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "150px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      <label class="custom-control form-radio mb-2">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="radiosub_category"
                          checked={advancedFilters.sub_category === "Company"}
                          value={"Company"}
                          id={"Companysub_category"}
                          onChange={(e) => {
                            setAdvancedFilters({
                              ...advancedFilters,
                              sub_category: e.target.value,
                            });
                          }}
                        />
                        <span class="custom-control-label">
                          <label
                            htmlFor={"Companysub_category"}
                            class="text-dark mb-1"
                          >
                            Company
                          </label>
                        </span>
                      </label>
                      <label class="custom-control form-radio mb-2">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="radiosub_category"
                          checked={
                            advancedFilters.sub_category === "Individual"
                          }
                          value={"Individual"}
                          id={"Individualsub_category"}
                          onChange={(e) => {
                            setAdvancedFilters({
                              ...advancedFilters,
                              sub_category: e.target.value,
                            });
                          }}
                        />
                        <span class="custom-control-label">
                          <label
                            htmlFor={"Individualsub_category"}
                            class="text-dark mb-1"
                          >
                            Individual
                          </label>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="card-header">
                  <h3 class="card-title">Country</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "150px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter country"
                        name="country"
                        value={advancedFilters.country}
                        onChange={(e) => {
                          setAdvancedFilters({
                            ...advancedFilters,
                            country: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div class="card-header">
                  <h3 class="card-title">City</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "150px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      <input
                        type="text"
                        class="form-control"
                        name="city"
                        placeholder="Enter city"
                        value={advancedFilters.city}
                        onChange={(e) => {
                          setAdvancedFilters({
                            ...advancedFilters,
                            city: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div class="card-header">
                  <h3 class="card-title">Region</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "150px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      <input
                        type="text"
                        class="form-control"
                        name="region"
                        placeholder={
                          stateObj.activestatus !== "Active"
                            ? "Subscribe to Enter"
                            : "Enter region"
                        }
                        value={advancedFilters.region}
                        readOnly={stateObj.activestatus !== "Active"}
                        onChange={(e) => {
                          if (stateObj.activestatus === "Active")
                            setAdvancedFilters({
                              ...advancedFilters,
                              region: e.target.value,
                            });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div class="card-header">
                  <h3 class="card-title">Pincode</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "150px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      <input
                        type="text"
                        class="form-control"
                        name="pincode"
                        placeholder={
                          stateObj.activestatus !== "Active"
                            ? "Subscribe to Enter"
                            : "Enter pincode"
                        }
                        value={advancedFilters.pincode}
                        readOnly={stateObj.activestatus !== "Active"}
                        onChange={(e) => {
                          if (stateObj.activestatus === "Active")
                            setAdvancedFilters({
                              ...advancedFilters,
                              pincode: e.target.value,
                            });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div class="card-header">
                  <h3 class="card-title">Rating</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "150px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs d-flex flex-wrap">
                      {[1, 2, 3, 4, 5].map((item) => {
                        return (
                          <label
                            class="custom-control form-radio mb-2 no-wrap ms-3"
                            key={item}
                          >
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="radiorating"
                              checked={advancedFilters.rating == item}
                              value={item}
                              id={item + "rating"}
                              readOnly={stateObj.activestatus !== "Active"}
                              onChange={(e) => {
                                if (stateObj.activestatus !== "Active") {
                                  return errorToast(
                                    "Please subscribe to use this filter"
                                  );
                                }
                                setAdvancedFilters({
                                  ...advancedFilters,
                                  rating: e.target.value,
                                });
                              }}
                            />
                            <span class="custom-control-label">
                              <label
                                htmlFor={item + "rating"}
                                class="text-dark mb-1 align-items-center d-flex"
                              >
                                {item} <FaStar className="text-yellow ms-1" />
                              </label>
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div class="card-header">
                  <h3 class="card-title">
                    Years of&nbsp;
                    {advancedFilters.sub_category !== "Company"
                      ? "Experience"
                      : "Estabilished"}
                  </h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      maxHeight: "100px",
                      overflow: "auto",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
                        return (
                          <label
                            class="custom-control form-radio mb-3"
                            key={item}
                          >
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="radioexperience"
                              checked={advancedFilters.year == item}
                              value={item}
                              id={item + "experience"}
                              readOnly={stateObj.activestatus !== "Active"}
                              onChange={(e) => {
                                if (stateObj.activestatus !== "Active") {
                                  return errorToast(
                                    "Please subscribe to use this filter"
                                  );
                                }
                                setAdvancedFilters({
                                  ...advancedFilters,
                                  year: e.target.value,
                                });
                              }}
                            />
                            <span class="custom-control-label">
                              <label
                                htmlFor={item + "experience"}
                                class="text-dark mb-1"
                              >
                                {item}+ Years
                              </label>
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <label
                    onClick={() => setAdvanceAppliedFilters(advancedFilters)}
                    class="btn btn-secondary btn-block"
                  >
                    Apply Filter
                  </label>
                  <label
                    onClick={() => {
                      setAdvanceAppliedFilters("");
                      setAdvancedFilters({});
                    }}
                    class="btn btn-secondary btn-block"
                  >
                    Clear Filter
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xl-9 col-lg-8 col-md-12" data-select2-id="16">
              <div class=" mb-lg-0" data-select2-id="15">
                <div class="" data-select2-id="14">
                  <div class="item2-gl " data-select2-id="13">
                    <div class=" mb-0">
                      <div class="">
                        <div
                          class="bg-white p-5 item2-gl-nav d-md-flex"
                          data-select2-id="12"
                        >
                          {/* {serviceProviders.length > 0 ? (
                            <h6 class="mb-0 mt-2">
                              Showing {parseFloat(pageno) * 30 - 29} to&nbsp;
                              {parseFloat(pageno) * 30 - (30 - serviceProviders.length)}&nbsp;
                              entries
                            </h6>
                          ) : (
                            <h6 class="mb-0 mt-2">Showing 0 entries</h6>
                          )} */}
                          {/* <div class="d-flex  ms-auto">
                            <label class="me-2 mt-1 mb-sm-1">SortBy:</label>
                            <select
                              name="item"
                              class="form-control select-sm w-100 select2"
                              value={sortBy}
                              onChange={(e) => setSortBy(e.target.value)}
                            >
                              <option value="1">Latest</option>
                              <option value="2">Oldest</option>
                            </select>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane active" id="tab-12">
                        <div class="row">
                          {serviceProviders.length <= 0 && (
                            <div className="col-lg-12 col-md-12 col-xl-12">
                              <div className="card overflow-hidden">
                                <div class="text-dark text-center">
                                  <div class="iteam-all-icon">
                                    <img
                                      src={emptycart}
                                      class="imag-service"
                                      alt="No records"
                                      style={{ maxHeight: 200 }}
                                    />
                                  </div>
                                  <div class="item-all-text mt-5">
                                    <h5 class="text-body font-weight-bold">
                                      No Records Found
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {serviceProviders.map((item) => {
                            return (
                              <div
                                className="col-xl-4 col-lg-6 col-md-12"
                                key={item.memberid}
                              >
                                {item.usertypecategory.toLowerCase() ===
                                  "individual" ? (
                                  <IndividualGrid item={item} />
                                ) : (
                                  <CompanyGrid item={item} />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="center-block text-center">
                    <ul class="pagination mb-5">
                      <li
                        class={`page-item page-prev ${pageno > 1 ? "" : "disabled"
                          }`}
                        onClick={() => {
                          if (pageno > 1) {
                            //  setpageno(pageno - 1);
                            navigate(
                              `/allproviders?category=${selectCategories}&txt=${searchText || ""
                              }&location=${location || ""}&pageno=${parseFloat(pageno) - 1}`
                            );
                          }
                        }}
                      >
                        <label class="page-link">Prev</label>
                      </li>

                      <li
                        class={`page-item page-prev ${serviceProviders.length >= 30 ? "" : "disabled"
                          }`}
                        onClick={() => {
                          if (serviceProviders.length >= 30) {
                            // setpageno(pageno + 1);
                            navigate(
                              `/allproviders?category=${selectCategories}&txt=${searchText || ""
                              }&location=${location || ""}&pageno=${parseFloat(pageno) + 1}`
                            );
                          }
                        }}
                      >
                        <label class="page-link">Next</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AllProviders;